// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import { Button, FormControl, Paper, TextField } from '@mui/material'
import React from 'react'
import { Mutation } from 'react-apollo'
import { i18n } from '../../index'
import css from './feelingsMeterQuestions.css'
import { createQuestionMutation, getStationQuestions } from './feelingsMeterQuestionsQueries'

class FeelingMeterQuestionsForm extends React.PureComponent {
  state = {
    question: '',
  }
  updateQuestion = (e) => {
    this.setState({
      question: e.target.value,
    })
  }
  createQuestion = (mutation) => {
    const variables = {
      stationId: this.props.station.id,
      data: {
        question: this.state.question,
        active: false,
      },
    }
    mutation({
      variables: variables,
    })
    this.setState({
      question: '',
    })
  }

  render() {
    const { question } = this.state
    return (
      <Paper className={css.component}>
        <div className={css.inner}>
          <FormControl fullWidth className={css.formFields}>
            <TextField
              id='outlined-multiline-flexible'
              label={i18n.t('admin.feelingsMeterQuestions.question')}
              multiline
              fullWidth
              variant='outlined'
              maxRows='1'
              margin='normal'
              value={question}
              onChange={(e) => this.updateQuestion(e)}
            />
            <div className={css.saveButtonContainer}>
              <Mutation
                mutation={createQuestionMutation}
                refetchQueries={[
                  {
                    query: getStationQuestions,
                    variables: {
                      stationId: this.props.station.id,
                    },
                  },
                ]}
              >
                {(onMutate) => (
                  <Button
                    color='primary'
                    variant='contained'
                    size='large'
                    className={css.saveButton}
                    disabled={false}
                    onClick={() => this.createQuestion(onMutate)}
                  >
                    {i18n.t('buttons.save')}
                  </Button>
                )}
              </Mutation>
            </div>
          </FormControl>
        </div>
      </Paper>
    )
  }
}

export default FeelingMeterQuestionsForm
